import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';
import { 
  QuickAddOnApiResponse
} from '../components/dto/quickaddon.dto';

class QuickAddOnService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }
  async getQuickAddOnsFromCart(
    cartItems: any[], 
    limit: number = 8
  ): Promise<QuickAddOnApiResponse> {
    try {
      const isValidObjectId = (id: string) => /^[a-fA-F0-9]{24}$/.test(id);
      const productIds = cartItems
        .map(item => item.productId || item.id)
        .filter(id => typeof id === 'string' && isValidObjectId(id));
      const response = await this.__Apiservice.postRequest<QuickAddOnApiResponse>(
        `products/did-you-forget?limit=${limit}`,
        { productIds },
        { apiRoot: this.apiRootServer }
      );
      return response;
    } catch (error: any) {
      return {
        success: false,
        data: [],
        message: error?.response?.data?.message || 'Failed to load quick add-on products',
        error: error.message
      };
    }
  }
}
const quickAddOnService = new QuickAddOnService();
export default quickAddOnService;
